import { render } from "./VODUploadWidgetDrop.vue?vue&type=template&id=827b79d8&scoped=true"
import script from "./VODUploadWidgetDrop.vue?vue&type=script&lang=js"
export * from "./VODUploadWidgetDrop.vue?vue&type=script&lang=js"

import "./VODUploadWidgetDrop.vue?vue&type=style&index=0&id=827b79d8&scoped=true&lang=css"
import "./VODUploadWidgetDrop.vue?vue&type=style&index=1&id=827b79d8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-827b79d8"],['__file',"src/components/ui/VODUploadWidgetDrop.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "827b79d8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('827b79d8', __exports__)) {
    api.reload('827b79d8', __exports__)
  }
  
  module.hot.accept("./VODUploadWidgetDrop.vue?vue&type=template&id=827b79d8&scoped=true", () => {
    api.rerender('827b79d8', render)
  })

}


export default __exports__